import React from "react";
import { Menu, Space } from "antd";
import type { SourceFilter, SourceHierarchy } from "../../../../../../core/data/redux/leads-queue/types";

interface PublicFormMenuProps {
    sourceHierarchy: SourceHierarchy | null;
    activeFilter: SourceFilter;
    onChange: (filter: SourceFilter) => void;
}

const PublicFormMenu: React.FC<PublicFormMenuProps> = ({ sourceHierarchy, activeFilter, onChange }) => {
    if (!sourceHierarchy?.public_form) return null;
    const { public_form } = sourceHierarchy as any;

    const handleFilterChange = (shareLinkId: string | null) => {
        onChange({ level_1: null, level_2: shareLinkId, level_3: null });
    };

    const isActive = (linkId: string | null) => {
        if (linkId === null) return !activeFilter.level_2;
        return String(activeFilter.level_2) === String(linkId);
    };

    const getActiveFormName = () => {
        if (!activeFilter.level_2) return null;
        const active = public_form.find((link: any) => String(link.share_link_id) === String(activeFilter.level_2));
        return active?.link_name ?? null;
    };

    const activeFormName = getActiveFormName();

    return (
        <Menu selectedKeys={[activeFilter.level_2 ? String(activeFilter.level_2) : "all"]}>
            {activeFormName && (
                <>
                    <Menu.Item
                        key="active-filter"
                        disabled
                        style={{
                            backgroundColor: "#e6f7ff",
                            fontWeight: 600,
                            cursor: "default",
                            color: "#1890ff",
                        }}
                    >
                        <Space>
                            <i className="ti ti-filter" style={{ color: "#1890ff" }} />
                            <span>Active: {activeFormName}</span>
                        </Space>
                    </Menu.Item>
                    <Menu.Divider />
                </>
            )}

            <Menu.Item
                key="all"
                onClick={() => handleFilterChange(null)}
                style={isActive(null) ? { backgroundColor: "#f0f0f0", fontWeight: 500 } : {}}
            >
                <Space>
                    <i className="ti ti-list" />
                    <span>All Public Forms</span>
                </Space>
            </Menu.Item>

            <Menu.Divider />

            {public_form.map((link: any) => (
                <Menu.Item
                    key={String(link.share_link_id)}
                    onClick={() => handleFilterChange(String(link.share_link_id))}
                    style={isActive(String(link.share_link_id)) ? { backgroundColor: "#e6f7ff", fontWeight: 500 } : {}}
                >
                    <Space>
                        <i className="ti ti-link" />
                        <span>{link.link_name}</span>
                    </Space>
                </Menu.Item>
            ))}
        </Menu>
    );
};

export default PublicFormMenu;
